export default __webpack_public_path__ + "static/media/vbb-2.e8c48bff.jpg";